// extracted by mini-css-extract-plugin
export default {"input":"InputCustomType_input__wKfES"};